import React, { useState } from "react";
import { Button, Modal, Row, Col, Form } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import axios from "../axios/axios";
// import BodyTextEditor from "./BodyTextEditor";
import { message } from "antd";
import LoadingOverlay from "react-loading-overlay";
import { useSelector, useDispatch } from "react-redux";
import { setEscapeBuckRedeemModal, setApiCallForFetchingEscapeBuckAmount, setApiCallForFetchingEscapeRedeemHistory } from "../actions/escapeBucks.actions";

const TransferEscapeBucksModal = ({ show, handleClose }) => {
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(false);
    const [user, setUser] = useState(JSON.parse(localStorage.getItem("AuthData")));
    const history = useHistory();
    const [fromData, setFormData] = useState({
        transferAmount: null,
        memberEmail: "",
    });

    const validate = () => {

        if (!fromData.transferAmount || Number(fromData.transferAmount) <= 0) {
            message.error("Please enter a valid transfer amount");
            return false;
        }

        if (!fromData.memberEmail) {
            message.error("Please enter member username");
            return false;
        }

        // const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        // if (!emailRegex.test(fromData.memberEmail)) {
        //     message.error("Please enter a valid email address");
        //     return false;
        // }

        return true;
    };
    const handelChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    }
    const submitCode = async () => {
        if (!validate()) return;
        let userEmail = user?.data?.userName;
        if (userEmail == fromData.memberEmail) {
            message.error("You can't transfer to yourself");
            return;
        }
        setLoading(true);
        const config = {
            headers: {
                Authorization: `Bearer ${localStorage.getItem("AuthToken")}`,
            },
        };
        await axios
            .post(`/user/transfer-escape-bucks`, { fromData }, config)
            .then((res) => {
                if (res.data.status) {
                    message.success(res.data.message);
                    setFormData({
                        transferAmount: null,
                        memberEmail: "",
                    });
                    dispatch(setApiCallForFetchingEscapeBuckAmount(true));
                    dispatch(setApiCallForFetchingEscapeRedeemHistory(true));
                    handleClose();
                    setLoading(false);
                } else {
                    setLoading(false);
                    message.error(res.data.message);
                }
            })
            .catch((err) => {
                setLoading(false);
                console.log("err", err);
                message.error("Something went wrong. Please try again");
            });
    }
    return (
        <>
            <Modal show={show} onHide={handleClose}>
                <Modal.Body>
                    <div className="modal_close">
                        <h3>Transfer Credits to Another Member</h3>
                        <Button
                            variant="secondary"
                            onClick={handleClose}
                            className="close_buuut"
                        ></Button>
                    </div>
                    <LoadingOverlay active={loading} spinner text="Loading ...">
                        <Row className="mt-4">

                            <Col md={12}>
                                <Form className="mt-3">
                                    <Row>
                                        <Col lg="12" md="6" sm="12">
                                            <Form.Group className="" controlId="formBasicEmail">
                                                <Form.Label>Amount of Credits Transferring</Form.Label>
                                                <Form.Control
                                                    type="number"
                                                    placeholder="2500"
                                                    name="transferAmount"
                                                    className=""
                                                    value={fromData.transferAmount}
                                                    onChange={handelChange}
                                                />
                                            </Form.Group>
                                            <Form.Group className="" controlId="formBasicEmail">
                                                <Form.Label>Member Username</Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    placeholder="johndoe"
                                                    name="memberEmail"
                                                    className=""
                                                    value={fromData.memberEmail}
                                                    onChange={handelChange}
                                                />
                                            </Form.Group>
                                        </Col>
                                        <Col lg="12" md="6" sm="12" className="text-center">
                                            <Form.Group className="mt-3" controlId="formBasicEmail">
                                                <Button
                                                    variant="primary"
                                                    type="button"
                                                    className="sub_but"
                                                    onClick={submitCode}
                                                >
                                                    Submit
                                                </Button>
                                            </Form.Group>
                                        </Col>
                                    </Row>


                                </Form>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={12} className="text-center mt-2">
                                <small>*Member must have an active account</small>
                            </Col>
                        </Row>
                    </LoadingOverlay>
                </Modal.Body>
            </Modal>
        </>
    );
};

export default TransferEscapeBucksModal;
